import React, { Component } from 'react';
import Layout from '../../common/Layout';
import PropTypes from 'prop-types';
// import { Query } from "@apollo/client/react/components"; // TODO: Replaced with REST hook
import DataTable from '../../common/components/data-table/DataTable';
import AddItemButton from '../../common/components/base/AddItemButton';
import SimpleSearch from "../../common/components/data-table/SimpleSearch";
// import { SecureQuery } from "../../settings/graphqlHelper"; // TODO: Replaced with REST hook
// import { DELETE_USER_GROUP, GET_USER_GROUPS } from "./queries"; // TODO: Both replaced with REST hooks
import { useUserGroups } from '../../hooks/useUserGroups';
import { useDeleteUserGroups } from '../../hooks/useDeleteUserGroups';
import AdminSettingsNavigation from '../adminSettings/AdminSettingsNavigation';
import TransferUsersToGroup from '../users/TransferUsersToGroup/TransferUsersToGroup';
import LoadingSpinner from "../../common/components/LoadingSpinner/LoadingSpinner";
import { Navigate } from 'react-router-dom';
import useAppStore from "../../store/appStore";
import { RolesTypes } from '../../constants/roles';

const columns = ["name", "referral link", "actions"];
const columnsToHide = ["groupChallenges"];

// Wrapper component to use hooks with class component
const UserGroupsDataWrapper = ({ name, page, component }) => {
  const { data, isLoading, error } = useUserGroups({ name, page });
  const deleteUserGroupMutation = useDeleteUserGroups();
  // Pass the delete mutation to the class component
  component.deleteUserGroupMutation = deleteUserGroupMutation;

  if (isLoading) return <LoadingSpinner boxed={true} styles={{ paddingTop: 40, marginTop: 15, marginBottom: 30 }} />;
  if (error) return `Error! ${error.message}`;

  const userGroups = {
    ...data.userGroups, 
    records: data.userGroups.records.map(item => ({
      ...item, 
      link: !item.isCareerPath ? window.location.origin + '/register/' + item._id : undefined
    }))
  };

  return (
    <DataTable 
      key={`${page}-${name}-${JSON.stringify(userGroups.records.map(r => r._id))}`}
      header='User Groups'
      editUrl="/admin-settings/userGroups/update/"
      pages={data.userGroups.pages}
      columns={columns}
      records={userGroups}
      deleteRow={component._deleteRow}
      keyColumn='_id'
      page={page}
      first={component._first}
      last={component._last.bind(component, data.userGroups.pages)}
      next={component._nextPage}
      previous={component._previousPage}
      columnsToHide={columnsToHide}
      handleCustomActionClick={component.handleCustomActionClick.bind(component)}
      hasCustomAction={(() => {
        const user = useAppStore.getState().user.me;
        return user && user.userRole === RolesTypes.SUPERUSER;
      })()}
      showDeleteIcon={(record) => {
        const user = useAppStore.getState().user.me;
        return user && user.userRole === RolesTypes.SUPERUSER;
      }}
    />
  );
};

class UserGroups extends Component {
  static propTypes = {
    page: PropTypes.number,
  };
  
  constructor(props) {
    super(props);
    this.state = { name: '', page: 0, open: false, userGroupId:null, userList:[] };
    this._first = this._first.bind(this);
    this._nextPage = this._nextPage.bind(this);
    this._previousPage = this._previousPage.bind(this);
    this._deleteRow = this._deleteRow.bind(this);
    this._keyPress = this._keyPress.bind(this);
    this._add = this._add.bind(this);
    this.handleCustomActionClick = this.handleCustomActionClick.bind(this);
    //this.handleClose = this.handleClose.bind(this);
  }

  _previousPage(e) {
    e.preventDefault();
    if (this.state.page > 0) {
      this.setState({ page: this.state.page - 1 });
    }
  }

  _first(e) {
    e.preventDefault();
    this.setState({ page: 0 });
  }

  _nextPage(e) {
    e.preventDefault();
    this.setState({ page: this.state.page + 1 });
  }

  _last(pages, e) {
    e.preventDefault();
    this.setState({ page: pages - 1 });
  }

  _deleteRow(event) {
    const { mutate, isLoading } = this.deleteUserGroupMutation;
    
    if (isLoading) return; // Prevent multiple calls while deleting
    
    mutate(event.id.id, {
      onSuccess: () => {
        console.log('User group deleted successfully');
        // The cache invalidation is handled automatically in the hook
      },
      onError: (error) => {
        console.error('Error deleting user group:', error);
      }
    });
  }

  _keyPress(e) {
    if (e.keyCode === 13) {
      this.setState({
        name: e.target.value,
        page: 0
      });
    }
  }

  _add() {
    this.props.history.push("/admin-settings/userGroup")
  }

  handleCustomActionClick(data){
    this.setState({userGroupId: data._id, open: true})
  }

  handleClose = () => {
    this.setState({userGroupId: null, open: false})
  };
  
  render() {
    const user = useAppStore.getState().user;
    if(this.props.location.pathname.includes('update') && !this.props.match.params.id)
    return (
      <Navigate
      to="../userGroups"
      replace
    />
  )
    return (
      <Layout name="User Group">
        <div className="wizard-container">
          { user.me && user.me.userRole === RolesTypes.SUPERUSER && <AddItemButton OnClick={this._add} />}
          <AdminSettingsNavigation path={this.props.match.path} />
          <div className="row">
            <div className="col-sm-12 col-md-10" />
            <div className="col-sm-12 col-md-2">
              <SimpleSearch keyPress={this._keyPress} />
            </div>
          </div>
          <UserGroupsDataWrapper 
            name={this.state.name}
            page={this.state.page}
            component={this}
          />
          {this.state.userGroupId!==null && <TransferUsersToGroup userList={this.state.userList} userGroupId={this.state.userGroupId} open={this.state.open} handleClose={this.handleClose}></TransferUsersToGroup>}
            </div>
      </Layout>
    );
  }
}

export default UserGroups;
